import * as swcHelpers from '@swc/helpers';
import { mapGraphProductToClientProduct } from '../mappers/server-to-client/map-to-client-product.js';
import { GET_PRODUCT_BY_SLUG } from '../operations/queries/get-product-by-slug.js';

function getProductBySlug(_) {
    return _getProductBySlug.apply(this, arguments);
}
function _getProductBySlug() {
    _getProductBySlug = swcHelpers.asyncToGenerator(function*({ client , slug , locale  }) {
        const queryResult = yield client.query({
            query: GET_PRODUCT_BY_SLUG,
            variables: {
                slug,
                facets: []
            },
            context: {
                headers: {
                    'Accept-Language': locale
                }
            }
        });
        if (queryResult.error) {
            console.error(queryResult.error);
            throw queryResult.error;
        }
        const serverProduct = queryResult.data.getProductBySlug.product;
        if (serverProduct === null || serverProduct === undefined) {
            console.error(`Received a null or undefined product from the BE for slug: "${slug}"`);
            return;
        }
        return mapGraphProductToClientProduct(serverProduct, slug, locale);
    });
    return _getProductBySlug.apply(this, arguments);
}

export { getProductBySlug };
//# sourceMappingURL=getProductBySlug.js.map
